import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { MenuDataService } from '@services/aplicacao-service/data/menu-data.service';
import { DashboardService } from '@services/dashboard/dashboard.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;

  // Dummy notifications
  notifications = [
    {
    message: 'New contact added',
    icon: 'assignment_ind',
    time: '2 Refere',
    route: '/inbox',
    color: 'primary'
  }, {
    message: '2 Referência para tratar',
    icon: 'chat',
    time: '0 min',
    route: '/facturacao/referencia-multicaixa/tratar',
    color: 'accent'
  }, {
    message: 'Server rebooted',
    icon: 'settings_backup_restore',
    time: '12 min ago',
    route: '/charts',
    color: 'warn'
  }
]

MENU = {
  VENDA: "FACTUR",
  COMPRA: "COMPRA",
  TESOURARIA: "TESOUR",
  ENTIDADE: "CLIENT",
  ARTIGO: "ARTIGO",
  DASHBO: "DASHBO",
};
  Menu_Vendas: boolean;

  constructor(private router: Router,  private dashboardService: DashboardService,private menuStore: MenuDataService) {
    this.menusAplicacao();
  }

  menusAplicacao() {
    this.menuStore.getListaMenus().subscribe((menus) => {
      this.Menu_Vendas = menus.findIndex((m) => m.codMenu === this.MENU.VENDA) !== -1;
      if(this.Menu_Vendas){
        this.getNotificacoeaFincanca();
      }
    });
  }

  getNotificacoeaFincanca() {
    this.dashboardService.notificacoes().subscribe((m) => {
      const dados = m.objecto;
      this.notifications = dados?.notifications;
      console.log("Vendas notifications:: ",this.notifications);

    
    },error=>{
      console.log("Erro das notificacoes fin",error);
    })  }

  ngOnInit() {
    this.router.events.subscribe((routeChange) => {
        if (routeChange instanceof NavigationEnd) {
          this.notificPanel.close();
        }
    });
  }
  clearAll(e) {
    e.preventDefault();
    this.notifications = [];
  }

      // return this.router.navigateByUrl(
    //   "facturacao/referencia-multicaixa/tratar"
    // );
    
}
